import {observer} from 'mobx-react';
import LabelHelper from 'shared/components/LabelHelper';
import FormError from 'shared/components/FormError';
import moment from 'moment';
import _ from 'lodash';

const WeekdaySelector = observer(({label, selectedDays, onChange, errorMessage, weekStart = moment.localeData().firstDayOfWeek()}) => {
  const days = _.range(7).map(offset => (weekStart + offset) % 7);

  return (
    <div>
      {label && <LabelHelper label={label}/>}
      <div className='WeekdaySelector'>
        {days.map(day => (
          <div
            key={day}
            className={`WeekdaySelector-day ${_.includes(selectedDays, day) ? 'WeekdaySelector-day--selected' : ''}`}
            onClick={() => onChange(_.xor(selectedDays, [day]))}
          >
            {moment.weekdaysShort()[day]}
          </div>
        ))}
      </div>
      <FormError message={errorMessage}/>
    </div>
  );
});

export default WeekdaySelector;
